import { Button, Form, Input, Modal, Select, Space, Drawer, InputRef } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { connect } from "react-redux";
import { AppState } from "src/store";
import style from './Tables.module.scss'
import { useEffect, useRef, useState } from "react";
import { getAllPcg, GetPcgById, postRegisterPcg, putUpdatePcg } from "src/store/pcg/thunks";
import { SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined } from '@ant-design/icons';
import { SizeType } from "antd/es/config-provider/SizeContext";
import validateMessages from "src/globals/Inputs/validateMessages";
import TextArea from "antd/es/input/TextArea";
import form from "antd/es/form";
import { NamePath } from "antd/es/form/interface";
import { PcgSource } from "src/store/pcg/types";
import { validate1, validate150, validateNumber } from "src/globals/Inputs/validateInput";
import { getUserByToken } from "src/store/user/thunks";
import { ColumnType, FilterConfirmProps } from "antd/es/table/interface";


interface TableProps {
    getAllPcg?: any;
    putUpdatePcg?: any;
    postRegisterPcg?: any;
    GetPcgById?: any;
    getUserByToken?:any;
}

/*id:string
    name:string,
    type:string,    
    description:string,
    created_at:string*/

interface DataType {
    key: string;
    id: string;
    formula: string;
    name: string;
    pcgValue: number;
    compound: string;
    pcg: string;
    created_at: string;
    updated_at: string;
}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';
const TPcg: React.FC<TableProps> = (props: TableProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [typeModal, setTypeModal] = useState(true);
    const [idPcg, setIdPcg] = useState('');
    const [formValidate] = Form.useForm();
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const searchInput = useRef<InputRef>(null);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [isRol, setIsRol] = useState('');
    const { Option } = Select;
    //LLamar al EndPoint tanto en el Iterface como en el Map, 
    const init = async () => {
        const rol = await props.getUserByToken();
        setIsRol(rol);
        const responseDataPcg = await props.getAllPcg();
        setDataTable(responseDataPcg);
    }
    useEffect(() => {
        init();
    }, []);

    //Crear una tabla.
    const [dataTable, setDataTable] = useState([]);
    
    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };    
    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });

    const columns: ColumnsType<DataType> = [
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Nombre',
            width: 25,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            ...getColumnSearchProps('name', 'nombre'),
            sorter: (a, b) => {
                const dateA = new Date(a.name);
                const dateB = new Date(b.name);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Compuesto',
            width: 20,
            dataIndex: 'compound',
            key: 'compound',
            //fixed: 'left',
            ...getColumnSearchProps('compound', 'Compuesto'),
            sorter: (a, b) => {
                const dateA = new Date(a.compound);
                const dateB = new Date(b.compound);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Formula',
            width: 20,
            dataIndex: 'formula',
            key: 'formula',
            //fixed: 'left',
            ...getColumnSearchProps('formula', 'Formula'),
            sorter: (a, b) => {
                const dateA = new Date(a.formula);
                const dateB = new Date(b.formula);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'PCG',
            dataIndex: 'pcgValue',
            key: 'pcgValue',
            width: 20,
            ...getColumnSearchProps('pcgValue', 'PCG'),
            sorter: (a, b) => {
                const dateA = new Date(a.pcgValue);
                const dateB = new Date(b.pcgValue);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Fecha de creación',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 15,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },
        {
            title: 'Fecha de modificación',
            dataIndex: 'updated_at',
            key: 'updated_at',
            width: 15,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.updated_at);
                const dateB = new Date(b.updated_at);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },     

    ];

    if (isRol === "ec438afc-63f2-4acf-b1d4-e51df3043190") {
        columns.push({
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 5,
            render: (record: DataType) => (
                <Space size="middle">
                    <Button
                        type="text"
                        className={style["update-button"]}
                        onClick={() => handleTypeOpenModelUpdate(record.id)}
                        icon={<EditOutlined />}
                    />
                </Space>
            ),
        });
    }
    
    const handleCancel = () => {
        formValidate.resetFields();
        setIsModalOpen(false)
    };
    const handleTypeOpenModel = () => {
        setIsModalOpen(true)
        setTypeModal(true)
    };
    const handleTypeOpenModelUpdate = async (value: String) => {
        setIsModalOpen(true)
        setTypeModal(false)
        const responseData: PcgSource = await props.GetPcgById(value);
        setIdPcg(responseData.id)
        formValidate.setFieldsValue({
            name: responseData.name, compound: responseData.compound ,formula: responseData.formula, pcgValue: responseData.pcgValue
        });
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const onFinish = async (values: any) => {
        if (!typeModal) {
            const PcgSource = {
                id: idPcg,                
                name: values.name,
                compound: values.compound,
                formula: values.formula,
                pcgValue: values.pcgValue,
            };
            await props.putUpdatePcg(PcgSource);
        } else {
            const PcgSourse = {
                name: values.name,
                compound: values.compound,
                formula: values.formula,
                pcgValue: values.pcgValue,
            };
            await props.postRegisterPcg(PcgSourse);
        }
        handleCancel();
        const responseData = await props.getAllPcg();
        setDataTable(responseData);
        formValidate.resetFields();
    };

    return (
        <>
            { isRol == "ec438afc-63f2-4acf-b1d4-e51df3043190" &&<Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={handleTypeOpenModel}
            >
                Crear PCG
            </Button>}
            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1500 }} />
            <Drawer title= {typeModal ? "Crear PCG" : "Actualizar PCG"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item  label="Nombre" name="name" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input   placeholder="Ingresar nombre" />
                    </Form.Item>
                    <Form.Item  label="Ingresar compuesto" name="compound" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input  placeholder="Ingresar formula" />
                    </Form.Item>
                    <Form.Item  label="Formula" name="formula" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input  placeholder="Ingresar formula" />
                    </Form.Item>
                    <Form.Item label="PCG" name="pcgValue" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateNumber(value) },
                    ]}>
                        <Input placeholder="Ingresar PCG" />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Ingresar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>


    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getAllPcg, GetPcgById, postRegisterPcg, putUpdatePcg,getUserByToken
})(TPcg);